import { HStack } from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Button, Show } from 'shared';

import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { useCancelSession } from 'features/sessions/hooks/useCancelSession';
import { useRescheduleSession } from 'features/sessions/hooks/useRescheduleSession';
import { useSessionPageCancelSessionMutateOptions } from 'features/sessions/hooks/useSessionPageCancelSessionMutateOptions';
import { useSessionPageRescheduleMutateOptions } from 'features/sessions/hooks/useSessionPageRescheduleMutateOptions';

import { Typography } from 'shared/components/Typography';

export const CoachSessionActions = () => {
  const attendance = useWatch({
    name: 'attendance',
  });

  const { getValues } = useFormContext();
  const [sessionId, sessionStartAt, sessionEndAt, coachingMode] = getValues([
    'coachingSessionId',
    'startAt',
    'endAt',
    'coachingMode',
  ]);

  const cancelMutateOptions =
    useSessionPageCancelSessionMutateOptions(sessionId);
  const rescheduleMutateOptions =
    useSessionPageRescheduleMutateOptions(sessionId);

  const { handleCancelModalOpen } = useCancelSession(
    sessionId,
    cancelMutateOptions
  );
  const { handleRescheduleModalOpen } = useRescheduleSession({
    sessionId,
    sessionStartAt,
    sessionEndAt,
    options: rescheduleMutateOptions,
    coachingMode,
  });

  const isActionButtonsVisible =
    attendance === SESSION_ATTENDANCE_STATUS.SCHEDULED ||
    attendance === SESSION_ATTENDANCE_STATUS.RESCHEDULED ||
    attendance === SESSION_ATTENDANCE_STATUS.ATTENDED;

  return (
    <Show when={isActionButtonsVisible}>
      <HStack gap={3}>
        <Button
          variant="outline"
          onClick={handleRescheduleModalOpen}
          data-testid="sidebar-reschedule-session"
        >
          <Typography as="span" fontWeight="medium">
            Reschedule
          </Typography>
        </Button>
        <Button
          variant="outline"
          onClick={handleCancelModalOpen}
          data-testid="sidebar-cancel-session"
        >
          <Typography as="span" fontWeight="medium">
            Cancel
          </Typography>
        </Button>
      </HStack>
    </Show>
  );
};
